export default class FruitAnimation {
  constructor({ section = document }) {
    this.section = section;
    this.init();
  }

  init() {
    //This function sets the start of the scroll animation to the current start of the window + 100vh. It can be called as a callback to another animation, which is perfect.
    const parallaxFruit = (fruit, section) => {
      const curTop = window.scrollY;
      let scrollTl = gsap.timeline({
        scrollTrigger: {
          trigger: "body",
          start: `${curTop} top`,
          end: `${curTop + window.innerHeight} top`,
          scrub: true,
        },
      });

      scrollTl.fromTo(
        fruit,
        {
          y: `0%`,
        },
        {
          y: `50%`,
        },
        0
      );
    };

    const horizontaParallax = (fruit, scrollSection) => {
      let scrollTl = gsap.timeline({
        scrollTrigger: {
          scroller: scrollSection,
          horizontal: true,
          start: "left left",
          end: `+=${scrollSection.scrollWidth}`,
          scrub: true,
        },
      });

      scrollTl.fromTo(
        fruit,
        {
          x: `0%`,
        },
        {
          x: `-100%`,
        },
        0
      );
    };

    const popInFruitOnScroll = (fruit, section) => {
      return new Promise((resolve, reject) => {
        //SVG allows for badge to be included in this
        const fruitImage = fruit.querySelector("img");
        gsap.set(fruit, { opacity: 1 });
        gsap.set(fruitImage, { scale: 0 });
        gsap.fromTo(
          fruitImage,
          {
            scale: 0,
          },
          {
            scale: 1,
            duration: 1.5,
            ease: "elastic.inOut",
            // immediateRender: false,
            scrollTrigger: {
              trigger: fruit,
              start: "center bottom",
            },
            onComplete: resolve,
          }
        );
      });
    };

    const fallInFruit = (fruit, section) => {
      return new Promise((resolve, reject) => {
        gsap.fromTo(
          fruit,
          {
            opacity: 0,
            y: `-100%`,
          },
          {
            delay: 0.5,
            opacity: 1,
            y: `0%`,
            duration: 1.2,
            onComplete: resolve,
          }
        );
      });
    };

    this.section.querySelectorAll(".fruit").forEach((fruit) => {
      const section = fruit.closest(".shopify-section");
      const isInRevealHeroSection = !!section?.querySelector("reveal-hero");
      const isInFeaturedProductsInlineSection = !!fruit?.closest(
        ".featured-products-inline"
      );
      const isFirstSection =
        section == section?.parentElement?.firstElementChild;
      const isLastSection = section == section?.parentElement?.lastElementChild;

      if (window.designMode) return;

      if (
        (!isFirstSection || section?.classList.contains(",main-product")) &&
        !isInRevealHeroSection
      ) {
        popInFruitOnScroll(fruit, section).then(() => {
          if (isInFeaturedProductsInlineSection) {
            horizontaParallax(
              fruit,
              section?.querySelector(".featured-products-inline__inner")
            );
          } else {
            parallaxFruit(fruit, section);
          }
        });
      } else if (!isInRevealHeroSection) {
        fallInFruit(fruit, section).then(() => parallaxFruit(fruit, section));
      }
    });
  }

};
